import React, { lazy } from 'react';
import { Navigate } from 'react-router-dom';

import Loadable from '../layouts/full/shared/loadable/Loadable';
import AuthGoogleSuccess from 'src/views/authorization/AuthWithGoogleSuccess';
import ProtectedRoute from 'src/views/authentication/ProtectedRoute';
import StaffAccessRoute from 'src/views/authentication/StaffAccessRoute';
import SuperAdminRoute from 'src/views/authentication/SuperAdminRoute';
import AuthenticatedRoute from 'src/views/authentication/AuthenticatedRoute';
import { EventsProvider } from 'src/views/authentication/CustomersContext';
import { PunchCardsProvider } from 'src/views/authentication/PunchCardsContext';
import { QuestionnairesProvider } from 'src/views/authentication/QuestionnairesContex';
import { AppBar } from '@mui/material';
import { AuthProvider } from 'src/views/authentication/AuthContext';
import { LanguageProvider } from 'src/LanguageContext';
import { NotificationProvider } from 'src/layouts/full/vertical/header/NotificationContext';
import { StatusProvider } from 'src/layouts/full/vertical/header/StatusContext';
import { ChargeProvider } from 'src/components/pages/payments/ChargeContext';
import { StatsProvider } from 'src/components/pages/stats/StatsContext';
import { BusinessSettingsProvider } from 'src/components/pages/business-settings/BusinessSettingsContext';
import { ShopProvider } from 'src/components/pages/Products/ShopContext';
import { ProductsProvider } from 'src/components/pages/Products/ProductsContext';
import { AuthShopProvider } from 'src/components/pages/shop/AuthShopContext';
import { ToastProvider } from 'src/components/shared/ToastContext';
import SessionExpiredDialog from 'src/components/SessionExpiredDialog';

const WhatsAppEmbedSignup = Loadable(
  lazy(() => import('src/components/pages/whatsapp-embed-signup/WhatsAppEmbedSignup')),
);

const PaymentsSummary = Loadable(
  lazy(() => import('src/components/pages/payemnts-summary/PaymentsSummary')),
);

const Questionnaires = Loadable(lazy(() => import('src/components/pages/Questionnaires')));
const MultiCalendar = Loadable(
  lazy(() => import('src/components/pages/multi-calendar/MultiCalendar')),
);

const AppointmentsWrapper = Loadable(lazy(() => import('src/components/pages/AppoitmentWrapper')));
// const Appointments = Loadable(lazy(() => import('src/components/pages/Appoitments')));

const FullLayout = Loadable(lazy(() => import('../layouts/full/FullLayout')));
const BlankLayout = Loadable(lazy(() => import('../layouts/blank/BlankLayout')));

// const MonthlyCalendar = Loadable(
//   lazy(() => import('src/components/pages/Appointments/MonthlyCalendar')),
// );
// const Calendar3DaysView = Loadable(
//   lazy(() => import('src/components/pages/Appointments/Calendar3DaysView')),
// );

// const AppointmentsMock = Loadable(lazy(() => import('../components/pages/AppointmentsMock')));
// const CalendarWeekViewMock = Loadable(
//   lazy(() => import('../components/pages/CalendarWeekViewMock')),
// );
// const TableMock = Loadable(lazy(() => import('../components/pages/TableMock')));

const WorkingHours = Loadable(lazy(() => import('../views/WorkingHours')));
const SearchTable = Loadable(lazy(() => import('../views/tables/SearchTable')));

const Customers = Loadable(lazy(() => import('../components/pages/customers/Customers')));
const RecurringAppointments = Loadable(
  lazy(() => import('../components/pages/recurring/RecurringAppointments')),
);
const PunchCards = Loadable(lazy(() => import('../components/pages/punchcards/PunchCards')));
const DuplicateAppointments = Loadable(
  lazy(() => import('../components/pages/duplicates/DuplicateAppointments')),
);

// const CustomersMock = Loadable(lazy(() => import('../components/pages/CustomersMock')));

const Login = Loadable(lazy(() => import('../views/authentication/auth1/Login')));
const Login2 = Loadable(lazy(() => import('../views/authorization/AuthWithGoogle')));

const Register = Loadable(lazy(() => import('../views/authentication/auth1/Register')));
const Register2 = Loadable(lazy(() => import('../views/authentication/auth2/Register2')));
const ForgotPassword = Loadable(lazy(() => import('../views/authentication/auth1/ForgotPassword')));
const ForgotPassword2 = Loadable(
  lazy(() => import('../views/authentication/auth2/ForgotPassword2')),
);
const TwoSteps = Loadable(lazy(() => import('../views/authentication/auth1/TwoSteps')));
const AuthLoginAdmin = Loadable(lazy(() => import('../views/authentication/auth1/AuthLogin')));
const TwoSteps2 = Loadable(lazy(() => import('../views/authentication/auth2/TwoSteps2')));
const Error = Loadable(lazy(() => import('../views/authentication/Error')));
const Maintenance = Loadable(lazy(() => import('../views/authentication/Maintenance')));

// const BusinssPage = Loadable(lazy(() => import('../book/src/components/BusinessPage')));
// const WhatsappRedirect = Loadable(lazy(() => import('../book/src/components/WhatsappRedirect')));

// const EditDetails = Loadable(lazy(() => import('../components/pages/editDetials/EditDetails')));
const Products = Loadable(lazy(() => import('../components/pages/Products')));
const Orders = Loadable(lazy(() => import('../components/pages/orders/Orders')));
const StatsDashboard = Loadable(lazy(() => import('../components/pages/stats/StatsDashboard')));
const BookingRouter = Loadable(
  lazy(() => import('../components/pages/web-scheduling/BookingRouter')),
);
// const TeamMangament = Loadable(
//   lazy(() => import('../components/pages/business-settings/TeamManagment')),
// );

const BusinessSettings = Loadable(
  lazy(() => import('../components/pages/business-settings/BusinessSettings')),
);

const Shop = Loadable(lazy(() => import('../components/pages/shop/Shop')));
const BusinessRegistration = Loadable(
  lazy(() => import('../components/pages/biz-registration/BusinessRegistration')),
);

const RegistrationSubmissionsAdmin = Loadable(
  lazy(() => import('../components/pages/admin/RegistrationSubmissionsAdmin')),
);

const RegistrationSubmissionDetail = Loadable(
  lazy(() => import('../components/pages/admin/RegistrationSubmissionDetail')),
);

const RegistrationSubmissionView = Loadable(
  lazy(() => import('../components/pages/admin/RegistrationSubmissionView')),
);

const BusinessesAdmin = Loadable(
  lazy(() => import('../components/pages/admin/BusinessesAdmin')),
);

const BusinessAdminDetail = Loadable(
  lazy(() => import('../components/pages/admin/BusinessAdminDetail')),
);

const SystemTagsAdmin = Loadable(
  lazy(() => import('../components/pages/admin/SystemTagsAdmin')),
);

// const BulkImportAdmin = Loadable(
//   lazy(() => import('src/components/pages/admin/BulkImportAdmin')),
// );

// AppointmentsMock

// Customers

const Router = [
  {
    path: '/register',
    element: (
      <AuthProvider>
        <LanguageProvider>
          <AuthenticatedRoute>
            <BusinessRegistration />
          </AuthenticatedRoute>
        </LanguageProvider>
      </AuthProvider>
    ),
  },
  {
    path: '/',
    element: (
      <AuthProvider>
        <LanguageProvider>
          <ToastProvider>
            <SessionExpiredDialog />
            <NotificationProvider>
            <StatusProvider>
              <ProductsProvider>
                <ChargeProvider>
                  <StatsProvider>
                    <BusinessSettingsProvider>
                      <EventsProvider>
                        <PunchCardsProvider>
                          <QuestionnairesProvider>
                            <FullLayout />
                          </QuestionnairesProvider>
                        </PunchCardsProvider>
                      </EventsProvider>
                    </BusinessSettingsProvider>
                  </StatsProvider>
                </ChargeProvider>
              </ProductsProvider>
            </StatusProvider>
            </NotificationProvider>
          </ToastProvider>
        </LanguageProvider>
      </AuthProvider>
    ),
    children: [
      { path: '/', element: <Navigate to="/manage/statistics" /> },

      // {
      //   path: '/mock/appointments',
      //   element: <AppointmentsMock />,
      // },
      // {
      //   path: '/mock/editDetails',
      //   element: <EditDetails />,
      // },
      // {
      //   path: '/mock/calendarweekview',
      //   element: <CalendarWeekViewMock />,
      // },

      // {
      //   path: '/mock/calendarweekview',
      //   element: <CalendarWeekViewMock />,
      // },

      {
        path: '/manage/questionnaires',
        element: (
          <ProtectedRoute>
            <Questionnaires />
          </ProtectedRoute>
        ),
      },

      {
        path: '/manage/payments',
        element: (
          <ProtectedRoute>
            <PaymentsSummary />
          </ProtectedRoute>
        ),
      },

      {
        path: '/manage/statistics',
        element: (
          <ProtectedRoute>
            <StatsDashboard />
          </ProtectedRoute>
        ),
      },

      {
        path: '/manage/team',
        element: (
          <ProtectedRoute>
            <BusinessSettings />
          </ProtectedRoute>
        ),
      },

      // {
      //   path: '/mock/team',
      //   element: (
      //     <ProtectedRoute>
      //       <TeamMangament />
      //     </ProtectedRoute>
      //   ),
      // },

      {
        path: '/manage/products',
        element: (
          <ProtectedRoute>
            <Products />
          </ProtectedRoute>
        ),
      },
      {
        path: '/manage/orders',
        element: (
          <ProtectedRoute>
            <Orders />
          </ProtectedRoute>
        ),
      },

      {
        path: '/manage/customersv2',
        element: <SearchTable />,
      },

      // {
      //   path: '/mock/weeklyview',
      //   element: <CalendarWeekView />,
      // },

      // {
      //   path: '/mock/3daysview',
      //   element: <Calendar3DaysView />,
      // },
      // {
      //   path: '/mock/customersv2',
      //   element: <CustomersMock />,
      // },
      {
        path: '/manage/workingHours',
        element: (
          <ProtectedRoute>
            <StaffAccessRoute>
              <WorkingHours />
            </StaffAccessRoute>
          </ProtectedRoute>
        ),
      },
      // {
      //   path: '/mock/customers',
      //   element: <TableMock></TableMock>,
      // },
      {
        path: '/manage/appointments',
        element: (
          <ProtectedRoute>
            <StaffAccessRoute>
              <AppointmentsWrapper />
            </StaffAccessRoute>
          </ProtectedRoute>
        ),
      },
      // {
      //   path: '/manage/monthly',
      //   element: (
      //     <ProtectedRoute>
      //       <MonthlyCalendar />
      //     </ProtectedRoute>
      //   ),
      // },
      {
        path: '/manage/appointments/mobile',
        element: (
          <ProtectedRoute>
            <AppointmentsWrapper />
          </ProtectedRoute>
        ),
      },
      {
        path: '/manage/customers',
        element: (
          <ProtectedRoute>
            <Customers />
          </ProtectedRoute>
        ),
      },
      {
        path: '/manage/recurring',
        element: (
          <ProtectedRoute>
            <RecurringAppointments />
          </ProtectedRoute>
        ),
      },
      {
        path: '/manage/punchcards',
        element: (
          <ProtectedRoute>
            <PunchCards />
          </ProtectedRoute>
        ),
      },
      {
        path: '/manage/duplicates',
        element: (
          <ProtectedRoute>
            <DuplicateAppointments />
          </ProtectedRoute>
        ),
      },
      {
        path: '/manage/multiCalendar',
        element: (
          <ProtectedRoute>
            <MultiCalendar />
          </ProtectedRoute>
        ),
      },

      {
        path: '/manage/registrations',
        element: (
          <ProtectedRoute>
            <SuperAdminRoute>
              <RegistrationSubmissionsAdmin />
            </SuperAdminRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: '/manage/registrations/:uid',
        element: (
          <ProtectedRoute>
            <SuperAdminRoute>
              <RegistrationSubmissionView />
            </SuperAdminRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: '/manage/registrations/:uid/edit',
        element: (
          <ProtectedRoute>
            <SuperAdminRoute>
              <RegistrationSubmissionDetail />
            </SuperAdminRoute>
          </ProtectedRoute>
        ),
      },

      {
        path: '/manage/businesses',
        element: (
          <ProtectedRoute>
            <SuperAdminRoute>
              <BusinessesAdmin />
            </SuperAdminRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: '/manage/businesses/:bizId',
        element: (
          <ProtectedRoute>
            <SuperAdminRoute>
              <BusinessAdminDetail />
            </SuperAdminRoute>
          </ProtectedRoute>
        ),
      },
      {
        path: '/manage/system-tags',
        element: (
          <ProtectedRoute>
            <SuperAdminRoute>
              <SystemTagsAdmin />
            </SuperAdminRoute>
          </ProtectedRoute>
        ),
      },

      // {
      //   path: '/manage/admin-import',
      //   element: (
      //     <ProtectedRoute>
      //       <BulkImportAdmin />
      //     </ProtectedRoute>
      //   ),
      // },

      { path: '*', element: <Navigate to="/auth/404" /> },
    ],
  },
  {
    path: '/',
    element: (
      <AuthProvider>
        <LanguageProvider>
          <BlankLayout />
        </LanguageProvider>
      </AuthProvider>
    ),
    children: [
      { path: '/auth/404', element: <Error /> },
      { path: '/auth/login2', element: <Login /> },
      { path: '/auth/google-calendar', element: <Login2 /> },
      { path: '/auth/google-calendar/success', element: <AuthGoogleSuccess /> },
      { path: '/auth/register', element: <Register /> },
      { path: '/auth/register2', element: <Register2 /> },
      { path: '/auth/forgot-password', element: <ForgotPassword /> },
      { path: '/auth/forgot-password2', element: <ForgotPassword2 /> },
      { path: '/auth/two-steps2', element: <TwoSteps2 /> },
      { path: '/auth/maintenance', element: <Maintenance /> },

      { path: '/auth/enterOtp', element: <TwoSteps /> },
      {
        path: '/auth/login',
        element: <AuthLoginAdmin />,
      },

      // {
      //   path: '/barberiaMenCare',
      //   element: <BusinssPage bizId="2e618204-9177-11ee-b9d1-0242ac120002" />,
      // },
      { path: '*', element: <Navigate to="/auth/404" /> },
      // { path: '/business/:businessName', element: <BusinssPage /> },
      // { path: '/message/:phoneNumber', element: <WhatsappRedirect /> },
    ],
  },
  {
    path: '/',
    element: <BlankLayout />,
    children: [
 

      {
        path: '/shop/:businessName',
        element: (
          <AuthShopProvider>
            <LanguageProvider>
              <ShopProvider>
                <AppBar sx={{ borderRadius: 0, '& .MuiPaper-root': { borderRadius: 0 } }}>
                  <Shop />
                </AppBar>
              </ShopProvider>
            </LanguageProvider>
          </AuthShopProvider>
        ),
      },
    ],
  },

  {
    path: '/',
    element: <BlankLayout />,
    children: [
      {
        path: '/onboard/whatsapp-signup',
        element: (
          // <AuthShopProvider>
          <LanguageProvider>
            <WhatsAppEmbedSignup />
          </LanguageProvider>
          // </AuthShopProvider>
        ),
      },
      {
        path: '/whatsapp-embed-signup',
        element: (
          // <AuthShopProvider>
          <LanguageProvider>
            <WhatsAppEmbedSignup />
          </LanguageProvider>
          // </AuthShopProvider>
        ),
      },
    ],
  },
];

export default Router;
